module.exports = __webpack_public_path__ + "static/media/tommi.0159cba3.jpeg";